<ng-container [formGroup]="form">
	<div gdColumns="repeat(auto-fill, minmax(230px, 1fr))" gdGap="10px">
		<mat-form-field gdColumn="span 2">
			<input matInput placeholder="Company Name" formControlName="name" maxlength="50"
				[required]="!form.disabled" />
			<mat-error *ngIf="!form.disabled">Required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<input autocomplete="employer-identification-number" matInput placeholder="Tax Id"
				formControlName="employerIdentificationNumber" maxlength="10" />
		</mat-form-field>
		<mat-form-field>
			<input matInput placeholder="Billing Contact First Name" formControlName="contactFirstName"
				[required]="!form.disabled" />
			<mat-error *ngIf="!form.disabled">Required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<input matInput placeholder="Billing Contact Last Name" formControlName="contactLastName"
				[required]="!form.disabled" />
			<mat-error *ngIf="!form.disabled">Required</mat-error>
		</mat-form-field>
		<mat-form-field>
			<input matInput placeholder="Phone Number" formControlName="phoneNumber" />
			<mat-error *ngIf="form.get('phoneNumber').hasError('required')">Required</mat-error>
			<mat-error *ngIf="form.get('phoneNumber').hasError('badPhoneNumber')">Invalid phone number
				format</mat-error>
		</mat-form-field>
	</div>
	<rpshared-billing-address-select *ngIf="allowAddressSelection && availableAddresses?.length > 0"
		[addresses]="availableAddresses" [selectedAddressId]="form.get('address').value?.id"
		(addressSelected)="onAddressSelected($event)"></rpshared-billing-address-select>
	<rpshared-address formControlName="address"></rpshared-address>
</ng-container>